import { render } from "./ContentComponentLoader.vue?vue&type=template&id=6307c545"
import script from "./ContentComponentLoader.vue?vue&type=script&lang=js"
export * from "./ContentComponentLoader.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\griff\\source\\repos\\Owen Associates\\Owen Associates\\Owen_Interiors\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__